import * as React from 'react';

function SvgArrowDownIcon(props) {
  return (
    <svg
      width={16}
      height={16}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.451 7.879h0l.003.003a.166.166 0 01.037.182.166.166 0 01-.037.054l-.001.002-3.328 3.328a.167.167 0 01-.053.032l-.01.005-.011.004a.126.126 0 01-.102 0l-.011-.004-.01-.005a.167.167 0 01-.053-.032L4.547 8.12l-.354.353.354-.353a.17.17 0 01.24-.24l2.192 2.2.854.856v-6.27a.167.167 0 11.333 0v6.27l.855-.856 2.193-2.2v-.001a.167.167 0 01.237 0z"
        fill="#fff"
        stroke="#FF5B5B"
      />
    </svg>
  );
}

export default SvgArrowDownIcon;
